import { Component, ElementRef, Input, OnInit, Renderer2, SimpleChanges } from '@angular/core';


@Component({
  selector: 'sl-column',
  standalone: true,
  imports: [],
  templateUrl: './sl-column.component.html',
})
export class SlColumnComponent implements OnInit {
  @Input()
  startRow!: number;
  @Input()
  endRow!: number;
  @Input()
  startColumn!: number;
  @Input()
  endColumn!: number;

  ngOnInit() {
    this.applyGridStyles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['startColumn'] || changes['endColumn']) {
      this.applyGridStyles();
    }
  }

  private applyGridStyles() {
    if (this.startRow) {
      this.renderer.setStyle(this.element.nativeElement, 'grid-row-start', this.startRow);
    }
    if (this.endRow) {
      this.renderer.setStyle(this.element.nativeElement, 'grid-row-end', this.endRow);
    }
    if (this.startColumn) {
      this.renderer.setStyle(this.element.nativeElement, 'grid-column-start', this.startColumn);
    }
    if (this.endColumn) {
      this.renderer.setStyle(this.element.nativeElement, 'grid-column-end', this.endColumn + 1);
    }
  }

  constructor(private readonly element: ElementRef, private readonly renderer: Renderer2) {}
}
